(ns manage.script-ocp.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Switch$default" :as Switch]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [manage.script-ocp.db :as form]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ocp-footer
  [{:keys [mode]}]
  ($ :<>
     (when (= mode :edit)
       ($ :<>
          ($ Alert {:severity "info"
                    :sx #js {:mb 2}}
             "Hosted scripts are cached, so it can take a few minutes to see your changes on production.")
          ($ Button {:variant "contained"
                     :color "error"
                     :onClick #(rf/dispatch [:modal/open {:id :script/confirm-delete}])}
             "Delete Script")))
     ($ Button
        {:type "submit"
         :variant "contained"}
        (if (= mode :create) "Create new Script" "Save Script"))))

(defmodal confirm-delete :script/confirm-delete
  [_]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:form.script/delete])
    :submit-button-disabled? (not @(rf/subscribe [:form.script/allowed-to-delete]))
    :entity-name "script"}
   [:p "When you delete this script there is no way back. Please type in the name of the script to confirm."]
   ($ input
      (merge (form/use-bind-control [:confirmation-name])
             {:sx #js {:mt 2}}))])

(defocp script-crud :script/crud
  {:width "40%"}
  [{:keys [script]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:form.script/init-form script])
                    (fn []
                      (rf/dispatch [:form.script/destroy])))
                  [script])
  (let [disabled (boolean (use-subscribe [:form.script/value :disabled]))]
    ($ ocp
       {:title (if script "Edit Script" "Create a new Script")
        :footer ($ ocp-footer {:mode (if script :edit :create)})
        :on-submit #(rf/dispatch [:form.script/submit])}
       ($ form-field
          {:label "Name"
           :err-msg (form/use-error-message [:name])
           :data-testid :script-form-input__name}
          ($ input (form/use-bind-control [:name])))
       ($ form-field
          {:label "Status"}
          ($ input
             {:value (if disabled "Disabled" "Enabled")
              :readOnly true
              :endAdornment ($ Switch
                               {:checked (not disabled)
                                :onChange #(rf/dispatch [:form.script/on-change [:disabled] (not disabled)])})}))
       (when-some [_ script]
         ($ form-field
            {:label "Include your script with the snippet below"}
            ($ input
               {:value (str "<script>\n"
                            "(function() {\n"
                            "  var e = document.createElement('script'); e.async = true;\n"
                            "  e.src = '" (:script-url script) "';\n"
                            "  var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);\n"
                            "})();\n"
                            "</script>")
                :readOnly true
                :multiline true
                :disabled disabled
                :rows 10})))
       ($ form-field
          {:label "Script"
           :err-msg (form/use-error-message [:script])
           :data-testid :script-form-textarea__script}
          ($ input
             (merge (form/use-bind-control [:script])
                    {:multiline true
                     :minRows 8
                     :disabled disabled}))))))
